
import { Link } from 'react-router';

const PLAN_STYLES: Record<string, { bg: string; text: string; label: string }> = {
  free: { bg: 'bg-muted', text: 'text-muted-foreground', label: 'Free' },
  pro: { bg: 'bg-violet-100 dark:bg-violet-900', text: 'text-violet-700 dark:text-violet-300', label: 'Pro' },
  beta: { bg: 'bg-amber-100 dark:bg-amber-900', text: 'text-amber-700 dark:text-amber-300', label: 'Beta' },
  enterprise: { bg: 'bg-zinc-900 dark:bg-zinc-100', text: 'text-white dark:text-zinc-900', label: 'Enterprise' },
};

export function PlanBadge({ plan }: { plan?: string | null }) {
  const resolvedPlan = plan || 'free';
  const style = PLAN_STYLES[resolvedPlan] || PLAN_STYLES.free;

  const badge = (
    <span className={`inline-flex items-center rounded-full px-2 py-0.5 text-xs font-medium ${style.bg} ${style.text} ${resolvedPlan === 'free' ? 'cursor-pointer hover:opacity-80 transition-opacity duration-150' : ''}`}>
      {style.label}
    </span>
  );

  if (resolvedPlan === 'free') {
    return (
      <Link to="/org/billing" aria-label="Upgrade plan">
        {badge}
      </Link>
    );
  }

  return badge;
}
